import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getRutas`, method: 'GET', body: null, token: token})
}
